import { useState, useContext, useRef, useLayoutEffect, useMemo, useEffect } from 'react';
import moment from 'moment';
import styled, { css } from 'styled-components';
import { PulseLoader } from 'react-spinners';
import Button from './Button';
import DatePicker from './Datepicker';
import PriceDetails from './PriceDetails';
import NightPriceText from './NightPriceText';
import SelectedDateContext from '../context/SelectedDateContext';
import PriceDetailsContext from '../context/PriceDetailsContext';
import ListingContext from '../context/ListingContext';
import InlineDatePicker from './InlineDatePicker';
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline';
type Props = {};

function MobileReservationFlow({}: Props) {
  const NUM_CALENDAR_INCREMENTS = 1;
  const [showModal, setShowModal] = useState(false);
  const [numCalendars, setNumCalendars] = useState(NUM_CALENDAR_INCREMENTS);

  const { listingId } = useContext(ListingContext);

  const [lastScrollPosition, setLastScrollPosition] = useState({ scrollTop: 0 });
  const [scrollPosition, setScrollPosition] = useState({ scrollTop: 0 });
  const scrollDemoRef = useRef(null);
  const [lastClear, setlastClear] = useState(0);

  useEffect(() => {
    if (scrollPosition.scrollTop === 0) {
      setTimeout(() => {
        console.log('now');
        /* @ts-ignore */
        scrollDemoRef.current.scrollTo(0, lastScrollPosition.scrollTop);
      }, 0);
    }
  }, [scrollPosition]);

  const handleScroll = () => {
    if (scrollDemoRef.current) {
      const { scrollTop } = scrollDemoRef.current;
      setLastScrollPosition({ scrollTop: scrollPosition.scrollTop });
      setScrollPosition({ scrollTop });
    }
  };

  // Ref to the
  const { selectedDateRange, setSelectedDateRange } = useContext(SelectedDateContext);

  const { isPriceDetailsPending, isPriceDetailsError, priceDetailsData, priceDetailsError } =
    useContext(PriceDetailsContext);

  const numNights =
    selectedDateRange.start && selectedDateRange.end
      ? moment(selectedDateRange.end).diff(moment(selectedDateRange.start), 'days')
      : 0;

  const getBookingLink = (): String | null => {
    if (!selectedDateRange.start || !selectedDateRange.end) {
      return `https://stay.hideout.house/checkout/${listingId}?numberOfGuests=2`;
    }
    return `https://stay.hideout.house/checkout/${listingId}?checkin=${moment(
      selectedDateRange.start
    ).format(
      'YYYY-MM-DD'
    )}&checkout=${moment(selectedDateRange.end).format('YYYY-MM-DD')}&numberOfGuests=2`;
  };

  const bookingLink = getBookingLink();

  const handleButtonClick = () => {
    setShowModal(!showModal);
    setNumCalendars(NUM_CALENDAR_INCREMENTS);
  };

  console.log('num calendars', numCalendars);

  const baseRate = priceDetailsData?.result?.components?.reduce((prev: any, curr: any) => {
    if (curr.name === 'baseRate') {
      prev = curr.total;
    }
    return prev;
  }, 0);

  const pricePerNight = numNights ? Math.round(baseRate / numNights) : 0;

  const renderButton = () => {
    if (selectedDateRange.end) {
      return <ReserveButton externalLink={bookingLink}>Reserve</ReserveButton>;
    }

    return <CheckDatesButton onClick={handleButtonClick}>Check availability</CheckDatesButton>;
  };

  return (
    <MobileBookingFlowWrapper>
      <BottomBarWrapper>
        <NightPriceText
          hasDates={!!selectedDateRange.end}
          isLoading={isPriceDetailsPending}
          pricePerNight={pricePerNight}
          selectedDateRange={selectedDateRange}
          showDateText={true}
          onClickDateText={() => setShowModal(true)}
        />
        {renderButton()}
      </BottomBarWrapper>
      <DateSelectModalWrapper showModal={showModal} onClick={() => setShowModal(false)}>
        <DateSelectModal
          ref={scrollDemoRef}
          onScroll={handleScroll}
          onClick={(e) => e.stopPropagation()}>
          {/* <CloseButton onClick={() => setShowModal(false)}>
            <StyledCloseOutline />
          </CloseButton> */}
          {/* <div onClick={() => setlastClear(lastClear + 1)}>clear dates</div> */}
          <InlineDatePicker
            columns={1}
            numCalendars={numCalendars}
            showBookButton={false}
            showPriceDetails={false}
            mobileModal={true}
            lastClear={lastClear}
          />
          {/* {scrollPosition.scrollTop !== 0 && numCalendars < 12 && (
            <Button onClick={() => setNumCalendars(numCalendars + NUM_CALENDAR_INCREMENTS)}>
              Add more
            </Button>
          )} */}
          <BottomModalBarWrapper>
            <NightPriceText
              hasDates={!!selectedDateRange.end}
              isLoading={isPriceDetailsPending}
              pricePerNight={pricePerNight}
              selectedDateRange={selectedDateRange}
            />
            <StyledButton onClick={handleButtonClick}>Save</StyledButton>
          </BottomModalBarWrapper>
        </DateSelectModal>
      </DateSelectModalWrapper>
    </MobileBookingFlowWrapper>
  );
}

const MobileBookingFlowWrapper = styled.div``;

const BottomBarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 20px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  z-index: 4;
`;

const StyledButton = styled(Button)<Props>`
  width: auto;
  max-width: none;
`;

const DateSelectModalWrapper = styled.div<{ showModal: boolean }>`
  position: fixed;
  top: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 0;
  transition: opacity 300ms;
  z-index: 9999;
  ${({ showModal }) =>
    showModal
      ? css`
          top: 0;
          opacity: 1;

          ${BottomModalBarWrapper}, ${DateSelectModal} {
            bottom: 0;
          }
        `
      : ''}
`;

const BottomModalBarWrapper = styled.div`
  position: fixed;
  bottom: -100%;
  width: 100%;
  padding: 20px;
  padding-top: 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  transition: bottom 300ms;
`;

const DateSelectModal = styled.div`
  position: fixed;
  bottom: -100%;
  /* height: calc(100% - 10px); */
  height: auto;
  width: 100%;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: bottom 300ms;
  overflow: scroll;
  padding-bottom: 70px;
`;

const PerNightText = styled.span`
  text-transform: uppercase;
  font-size: 12px;
  color: #7a7a7a;
`;

const PricePerNightText = styled.div`
  color: #7a7a7a;
  font-weight: 400;
  font-size: 16px;
`;

const AddDatesText = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #7a7a7a;
`;

const CloseButton = styled.div`
  position: absolute;
`;
const StyledCloseOutline = styled(CloseOutline)`
  width: 32px;
  color: #c4c4c4;
`;

const CheckDatesButton = styled(StyledButton)`
  background: #fff;
  border: 1px solid #000;
  color: #000;
`;

const ReserveButton = styled(StyledButton)`
  @keyframes TransitioningBackground {
    0% {
      background-position: 99% 100%;
    }
    100% {
      background-position: 1% 0%;
    }
    /* 100% {
      background-position: 1% 0%;
    } */
  }
  /* background: #5f8a5f; */
  background-image: linear-gradient(
    270deg,
    rgb(0, 0, 0),
    rgb(0, 0, 0),
    rgb(89, 89, 89),
    rgb(0, 0, 0),
    rgb(0, 0, 0)
  );
  background-size: 400% 400%;
  animation: TransitioningBackground 6s ease infinite;
  transition: 0.6s;
`;

export default MobileReservationFlow;
